/**
 * Dünne Hülle um fetch. Einziger Ort im Frontend, der HTTP kennt.
 * Fehler kommen immer als ApiFehler mit deutschem Text heraus, damit die
 * Bildschirme nichts über Statuscodes wissen müssen.
 */

export class ApiFehler extends Error {
  constructor(nachricht, status = 0) {
    super(nachricht)
    this.name = 'ApiFehler'
    this.status = status
  }
}

function mitParametern(pfad, params) {
  if (!params) return pfad
  const such = new URLSearchParams()
  for (const [schluessel, wert] of Object.entries(params)) {
    if (wert === undefined || wert === null || wert === '') continue
    such.set(schluessel, String(wert))
  }
  const text = such.toString()
  return text ? `${pfad}?${text}` : pfad
}

/**
 * Ohne Sitzung antwortet /api mit 401. Dann per Navigation zum Login — kein
 * fetch, damit die Weiterleitung zu Pocket-ID der Browser selbst macht.
 */
export function anmeldenWennNoetig(antwort) {
  if (antwort.status === 401) {
    window.location.href = '/auth/login'
    throw new ApiFehler('Anmeldung nötig …', 401)
  }
}

async function anfrage(pfad, optionen) {
  let antwort
  try {
    antwort = await fetch(pfad, optionen)
  } catch {
    throw new ApiFehler('Keine Verbindung zum Server', 0)
  }

  anmeldenWennNoetig(antwort)

  let rumpf = null
  try {
    rumpf = await antwort.json()
  } catch {
    rumpf = null
  }

  if (!antwort.ok) {
    throw new ApiFehler(rumpf?.message || 'Der Server hat die Anfrage abgelehnt', antwort.status)
  }
  return rumpf
}

function mitRumpf(methode) {
  return (pfad, rumpf) =>
    anfrage(pfad, {
      method: methode,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(rumpf ?? {}),
    })
}

export const api = {
  get: (pfad, params) => anfrage(mitParametern(pfad, params)),
  post: mitRumpf('POST'),
  put: mitRumpf('PUT'),
  del: (pfad, params) => anfrage(mitParametern(pfad, params), { method: 'DELETE' }),
}
